import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import { addNavigationBreadcrumb } from 'Utils/sentry/breadcrumbs';

class ScrollToTop extends Component {
  timer;
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.any,
    behavior: PropTypes.string
  };

  componentDidUpdate (prevProps) {
    const { location = {} } = this.props;
    const { location: prevLocation = {} } = prevProps;

    const { behavior = 'auto' } = location.state || {};

    smoothscroll.polyfill();

    if (location.pathname !== prevLocation.pathname) {
      addNavigationBreadcrumb(prevLocation.pathname, location.pathname);
      
      this.timer = setTimeout(function () {
        window.scrollTo({ top: 0, left: 0, behavior: behavior });
      }, 200);
    }
  }

  componentWillUnmount () {
    clearInterval(this.timer);
  }

  render () {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);

/**
   * @purpose       if u want to scroll top smoothly :)
   * @method        smoothscroll.polyfill()
   * @why_use_this  The Scroll Behavior specification has been introduced as an extension of the Window interface
   *                to allow for the developer to opt in to native smooth scrolling.
   *                To date this has only been implemented in Chrome, Firefox and Opera.
   * @info          Check out all the methods covered here: https://iamdustan.github.io/smoothscroll
   * @usage         wrap component <ScrollToTop> *...children component* </ScrollToTop>
   */


